import { render } from "./Contenedor1.vue?vue&type=template&id=7ffe55a3&scoped=true"
import script from "./Contenedor1.vue?vue&type=script&lang=js"
export * from "./Contenedor1.vue?vue&type=script&lang=js"

import "./Contenedor1.vue?vue&type=style&index=0&id=7ffe55a3&scoped=true&lang=css"

import exportComponent from "/Users/bencorp/Desktop/proyectos/Fitbar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ffe55a3"]])

export default __exports__